import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=63da764b&"
import script from "./Login.js?vue&type=script&lang=js&"
export * from "./Login.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63da764b')) {
      api.createRecord('63da764b', component.options)
    } else {
      api.reload('63da764b', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=63da764b&", function () {
      api.rerender('63da764b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/Login/Login.vue"
export default component.exports